import { getDefaultPath } from './../services/rest.js';
const { config } = window;
delete window.config;

async function defaultPath(){
	const path = await getDefaultPath();
	return path.toLowerCase();
}

export default {
	...config,
	...{ defaultPath: `/${getDefaultPath()}` }
};



// WEBPACK FOOTER //
// ./mobile-core/src/store/index.js